import { useAlertStore } from '../../store/alertStore'
import { useSettingsStore } from '../../store/settingsStore'
import { ALL_SEVERITIES, SEVERITY_COLORS } from '../../types/cap'
import type { Severity } from '../../types/cap'

export default function SeverityFilter() {
  const { filters, toggleSeverity } = useAlertStore()
  const theme = useSettingsStore((s) => s.theme)
  const activeSeverities = filters.severity

  return (
    <div className="flex flex-wrap gap-1.5 px-3 py-2">
      {ALL_SEVERITIES.map((severity: Severity) => {
        const active = activeSeverities.length === 0 || activeSeverities.includes(severity)
        const color = SEVERITY_COLORS[severity]
        return (
          <button
            key={severity}
            type="button"
            onClick={() => toggleSeverity(severity)}
            className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium border transition-all ${
              active ? 'opacity-100' : 'opacity-30 hover:opacity-60'
            }`}
            style={
              active
                ? { color, borderColor: color + '66', backgroundColor: color + '1a' }
                : theme === 'dark'
                  ? { color: '#6b7280', borderColor: '#374151', backgroundColor: 'transparent' }
                  : { color: '#6b7280', borderColor: '#d1d5db', backgroundColor: 'transparent' }
            }
            title={`${active ? 'Hide' : 'Show'} ${severity}`}
          >
            {severity}
          </button>
        )
      })}
      {activeSeverities.length > 0 && (
        <button
          type="button"
          onClick={() => useAlertStore.getState().setFilters({ severity: [] })}
          className="text-xs text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 px-2 py-1 transition-colors"
        >
          Clear
        </button>
      )}
    </div>
  )
}
